import {GAME_TYPES} from "../../../constants/game";

export const checkIfCurrentUserTurn = (gameType, userId, currentPlayer) => {
  // Просмотр записи матча: чисто пассивный, ничей ход не считается "моим",
  // даже если currentPlayer.id совпадает с userId зрителя (свой же матч)
  if (gameType === GAME_TYPES.REPLAY) {
    return false;
  }

  // Бот, которым вручную управляет этот пользователь (перехват управления
  // админом в сетевой игре, см. controlledBots), — его ход: проверка «бот
  // ходит сам» ниже для такого бота неверна
  if (gameType === GAME_TYPES.ONLINE && userId && currentPlayer?.isBot
    && currentPlayer.botControlledByUserId === userId) {
    return true;
  }

  if (currentPlayer && currentPlayer.isBot) {
    return false
  }

  if (!currentPlayer || gameType === GAME_TYPES.LOCAL) {
    return true;
  }
  return userId === currentPlayer.id;
}